export const STEP_LABELS = [
  "Company",
  "Contacts",
  "Structure",
  "Coverage",
  "Eligibility",
  "Payment",
  "Documents",
  "Review",
] as const;

export type StepLabel = (typeof STEP_LABELS)[number];

export const TOTAL_STEPS = STEP_LABELS.length;
